let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9LgPu")).then(() => parcelRequire('9E5B0'));